import { z } from 'zod';

const CourseInterestAreaQuery = z.array(z.object({
    Id: z.string(),
    Name: z.string(),
}));

export { CourseInterestAreaQuery };